import { DOCUMENT, AsyncPipe, NgClass, TitleCasePipe } from '@angular/common';
import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  input,
  inject,
} from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  ClientService,
  SplashScreenStateService,
  SubscriptionService,
  TimeconversionService,
  ToastMessageService,
} from '@fitness-force/api';
import { CONSTANTS_DATA } from '@fitness-force/constants';
import {
  PayModeLevel1,
  PlanCategory,
  PlanIntervalType,
  SignUpMode,
  SubscriptionStatus,
  TrackMode,
} from '@fitness-force/enum';
import { ErrorMsgComponent } from '@fitness-force/errors';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';

import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { EditorModule } from 'primeng/editor';
import { MessageModule } from 'primeng/message';

import { PopoverModule } from 'primeng/popover';
import { RippleModule } from 'primeng/ripple';
import { SkeletonModule } from 'primeng/skeleton';
import { StyleClassModule } from 'primeng/styleclass';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TimelineModule } from 'primeng/timeline';
import { TooltipModule } from 'primeng/tooltip';

import { BehaviorSubject, Observable, combineLatest, forkJoin, of, Subject, takeUntil } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';
import { timeLineService } from '../../../../filters/timeline.pipe';
import { SubscriptionDetailsComponent } from '../subscription-details/subscription-details.component';
import type {
  Client,
  NotificationError,
  PaymentMethod,
  PlanAddons,
  PlanSummary,
  PlanSummaryClient,
  TENANTSINTERFACE,
} from '@fitness-force/models';
import { Store } from '@ngrx/store';
import { TENANTS_INFO } from '@fitness-force/state';
import { QrCodeModule } from 'ng-qrcode';
import {
  FeatureFlagService,
  RouteStateService,
} from '@fitness-force/shared-utils';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { BillingComponent } from '@fitness-force/billing';
import { SubscriptionActionListComponent } from '../../../subscription-action-list/subscription-action-list.component';
import { ProgressBarModule } from 'primeng/progressbar';
import { ConfirmationService } from 'primeng/api';
import {
  PendingActionsPopupComponent,
  PendingMandatoryActionDetails,
} from '../pending-actions-popup/pending-actions-popup.component';

@Component({
  selector: 'subscription-list',
  templateUrl: './subscription-list.component.html',
  styleUrls: ['./subscription-list.component.scss'],
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    RippleModule,
    AvatarModule,
    TagModule,
    StyleClassModule,
    DialogModule,
    MessageModule,
    TableModule,
    PopoverModule,
    BlockUIModule,
    EditorModule,
    RouterModule,
    DividerModule,
    TimelineModule,
    DateTimeFormatPipe,
    SubscriptionDetailsComponent,
    SelectModule,
    ButtonModule,
    SkeletonModule,
    QrCodeModule,
    ErrorMsgComponent,
    ConfirmDialogModule,
    ConfirmPopupModule,
    ProgressBarModule,
    SubscriptionActionListComponent,
    BillingComponent,
    PendingActionsPopupComponent,
    TranslateModule,
    AsyncPipe,
    NgClass,
    TitleCasePipe,
    TooltipModule,
  ],
})
export class SubscriptionListComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);
  private readonly clientService = inject(ClientService);
  private readonly toastMessageService = inject(ToastMessageService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly translate = inject(TranslateService);
  private readonly timeService = inject(TimeconversionService);
  private readonly fb = inject(UntypedFormBuilder);
  private readonly confirmationService = inject(ConfirmationService);
  private readonly routerservice = inject(RouteStateService);
  private readonly featureFlagService = inject(FeatureFlagService);
  private readonly document = inject<Document>(DOCUMENT);
  private readonly subscriptionService = inject(SubscriptionService);
  private readonly splashScreen = inject(SplashScreenStateService);

  readonly clientId = input<number>(0);
  localClientId: number = 0;
  readonly client = input<Client>();
  private readonly destroy$ = new Subject<void>();
  allSubscriptions$ = new BehaviorSubject<any>([]);
  allSubscriptionsSingups$ = new BehaviorSubject<any>([]);
  allsignups$ = new BehaviorSubject<any>([]);
  showsubscriptionDetails: boolean = false;
  pendingDuesTableData: any[] = [];
  subscriptionProgress: any[] = [
    {
      title: 'Initiated',
      step: 1,
      status: 'Done',
    },
    {
      title: 'In-Progress',
      step: 2,
      status: 'Done',
    },
    {
      title: 'Completed',
      step: 3,
      status: 'Pending',
    },
  ];

  weekDays = [
    { key: 'Sunday', value: -1 },
    { key: 'Monday', value: -2 },
    { key: 'Tuesday', value: -3 },
    { key: 'Wednesday', value: -4 },
    { key: 'Thursday', value: -5 },
    { key: 'Friday', value: -6 },
    { key: 'Saturday', value: -7 },
  ];

  days: Array<string> = CONSTANTS_DATA.DAYS;
  subscriptionId: number = 0;
  tenantId: number = 0;
  btnLoading: boolean = false;
  reloadData: boolean = false;
  showSkeleton$ = new BehaviorSubject<boolean>(true);
  showSignUplink: boolean = false;
  getAccessTenantList$: any;
  allTenants: any;
  voidSignUpBtnLoading: boolean = false;
  voidSignUpPopup: boolean = false;
  VoidSubscriptionSignupForm: UntypedFormGroup = new UntypedFormGroup({});
  signUpDetails: any;
  subscriptionDetails: any;
  btnLoading$ = new BehaviorSubject<boolean>(false);
  ActivateMembershipPopup: boolean = false;
  activateMembership: boolean = false;
  showFreeDiscountApply = new BehaviorSubject(false);
  clientDetails: any;
  addDiscountedPeriod: boolean = false;
  showAddonSidebar: boolean = false;
  planId: number = 0;
  selectedAddons = new BehaviorSubject<PlanAddons[]>([]);
  clientSubscriptionData = new BehaviorSubject<any>({});
  planSummarydataObject: Observable<PlanSummary> | any;
  showBillingSidebar: boolean;
  selectedFilter: string = 'active';
  showQRCode: boolean = false;
  qrCodeLink: string = '';
  showPendingActionsPopup: boolean = false;
  selectedPendingDetails: PendingMandatoryActionDetails | null = null;
  selectedSubscriptionAutopay: boolean = false;
  selectedSubscriptionIsRecurring: boolean = false;

  ngOnInit(): void {
    this.showSkeleton$.next(true);
    this.componentInit();
  }

  componentInit() {
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      this.allTenants = tenant.all_tenant;
      if (this.tenantId > 0) {
        this.store.dispatch({ type: 'ROUTER_GO' });
      }
    });
    this.getAllSubscriptions();
    this.featureFlagService
      .getFlag$('staff_can_see_signup_link')
      .pipe(takeUntil(this.destroy$))
      .subscribe((staffCanSeeSignupLink) => {
        this.showSignUplink = !staffCanSeeSignupLink;
        this.changeDetectorRef.detectChanges();
      });
    this.VoidSubscriptionSignupForm = this.fb.group({
      void_reasons: ['', [Validators.required]],
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getAllSubscriptions() {
    this.showSkeleton$.next(true);
    const clientSubscriptionDetails$ = combineLatest([
      this.clientService.getSubscriptions(this.clientId()),
      this.clientService.getSubscriptionSignup(this.clientId()),
    ]);

    clientSubscriptionDetails$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {
        const signupItems = res[1]?.items ?? null;
        if (signupItems != null) {
          this.allsignups$.next(signupItems);
          this.allSubscriptionsSingups$.next(
            signupItems.filter(
              (x: any) => x.final_status.toLowerCase() != 'closed',
            ) || [],
          );
        } else {
          this.allsignups$.next([]);
          this.allSubscriptionsSingups$.next([]);
        }

        const items = res[0]?.items ?? null;
        if (items == null) {
          this.allSubscriptions$.next([]);
          this.finishSubscriptionLoad();
          return;
        }

        this.loadSubscriptionsWithOverrideFlag(items);
      },
      error: (error: any) => {
        this.toastMessageService.showError(error);
        this.showSkeleton$.next(false);
        this.changeDetectorRef.detectChanges();
      },
    });
  }

  private finishSubscriptionLoad(): void {
    this.showSkeleton$.next(false);
    this.changeDetectorRef.markForCheck();
    this.changeDetectorRef.detectChanges();
  }

  private loadSubscriptionsWithOverrideFlag(items: any[]): void {
    const needsDetailEnrichment = items.some(
      (item) => this.getStatusOverriddenValue(item) === undefined,
    );

    if (!needsDetailEnrichment) {
      this.allSubscriptions$.next(
        items.map((item) => this.normalizeSubscription(item)),
      );
      this.finishSubscriptionLoad();
      return;
    }

    forkJoin(
      items.map((item) => {
        const overrideValue = this.getStatusOverriddenValue(item);
        if (overrideValue !== undefined) {
          return of(
            this.normalizeSubscription({
              ...item,
              is_status_overridden: overrideValue,
            }),
          );
        }

        return this.clientService
          .getSubscriptionDetails(this.clientId(), item.id)
          .pipe(
            map((detail: any) =>
              this.normalizeSubscription({
                ...item,
                is_status_overridden:
                  this.getStatusOverriddenValue(detail) ?? false,
              }),
            ),
            catchError(() => of(this.normalizeSubscription(item))),
          );
      }),
    )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (enrichedItems) => {
          this.allSubscriptions$.next(enrichedItems);
          this.finishSubscriptionLoad();
        },
        error: () => {
          this.allSubscriptions$.next(
            items.map((item) => this.normalizeSubscription(item)),
          );
          this.finishSubscriptionLoad();
        },
      });
  }

  private getStatusOverriddenValue(
    subscription: Record<string, unknown> | null | undefined,
  ): boolean | undefined {
    if (!subscription) {
      return undefined;
    }

    const value =
      subscription['is_status_overridden'] ??
      subscription['isStatusOverridden'] ??
      subscription['IsStatusOverridden'];

    if (value === undefined || value === null) {
      return undefined;
    }

    return value === true || value === 'true' || value === 1;
  }

  private normalizeSubscription(subscription: any): any {
    const overrideValue = this.getStatusOverriddenValue(subscription);
    return {
      ...subscription,
      is_status_overridden: overrideValue ?? false,
    };
  }

  BacktoAllSubscriptions() {
    this.showsubscriptionDetails = false;
    if (this.reloadData) this.componentInit();
  }

  GetBillingFrequency(subscription: any): string {
    let translate: string = '';
    if (
      subscription.billing_interval_value &&
      subscription.billing_interval_type.toLowerCase() == 'month'
    ) {
      const ordinalSuffix = this.ordinalSuffixOfBillingCycle(
        subscription.bill_cycle_day,
      );
      if (subscription.billing_interval_value == 1) {
        this.translate
          .get('SUBSCRIPTIONS.ONE_MONTH_TYPE', {
            billingCycleDay: subscription.bill_cycle_day,
            ordinalSuffix: ordinalSuffix,
          })
          .subscribe((trans) => {
            translate = trans;
          });
      } else if (subscription.billing_interval_value == 2) {
        this.translate
          .get('SUBSCRIPTIONS.TWO_MONTH_TYPE', {
            billingCycleDay: subscription.bill_cycle_day,
            ordinalSuffix: ordinalSuffix,
          })
          .subscribe((trans) => {
            translate = trans;
          });
      } else if (subscription.billing_interval_value == 3) {
        this.translate
          .get('SUBSCRIPTIONS.THREE_MONTH_TYPE', {
            billingCycleDay: subscription.bill_cycle_day,
            ordinalSuffix: ordinalSuffix,
          })
          .subscribe((trans) => {
            translate = trans;
          });
      } else {
        this.translate
          .get('SUBSCRIPTIONS.MORE_MONTH_TYPE', {
            intervalValue: subscription.billing_interval_value,
            billingCycleDay: subscription.bill_cycle_day,
            ordinalSuffix: ordinalSuffix,
          })
          .subscribe((trans) => {
            translate = trans;
          });
      }
      return translate;
    } else if (
      subscription.billing_interval_value &&
      subscription.billing_interval_type.toLowerCase() == 'week'
    ) {
      let day: string = '';
      if (subscription.bill_cycle_day == 0)
        day = this.days[new Date(subscription.sign_up_date).getDay()];
      else
        day =
          this.weekDays.find((d) => d.value == subscription.bill_cycle_day)
            ?.key ?? '';
      if (subscription.billing_interval_value == 1) {
        this.translate
          .get('SUBSCRIPTIONS.WEEKLY_SUNDAY', { day: day })
          .subscribe((trans) => {
            translate = trans;
          });
      } else if (subscription.billing_interval_value == 2) {
        this.translate
          .get('SUBSCRIPTIONS.2WEEK_SUNDAY', { day: day })
          .subscribe((trans) => {
            translate = trans;
          });
      } else {
        this.translate
          .get('SUBSCRIPTIONS.MORE_WEEK', {
            intervalType: subscription.billing_interval_value,
            day: day,
          })
          .subscribe((trans) => {
            translate = trans;
          });
      }
      return translate;
    } else {
      return subscription.billing_interval_type;
    }
  }

  ordinalSuffixOfBillingCycle(billingCycleDate: number) {
    const billingCycleDateBuff = billingCycleDate % 10;
    const billingCycleDateBuffAvg = billingCycleDate % 100;
    if (billingCycleDateBuff == 1 && billingCycleDateBuffAvg != 11) {
      return 'st';
    }
    if (billingCycleDateBuff == 2 && billingCycleDateBuffAvg != 12) {
      return 'nd';
    }
    if (billingCycleDateBuff == 3 && billingCycleDateBuffAvg != 13) {
      return 'rd';
    }
    return 'th';
  }

  reloadDates(next_Billing_Date: any) {
    const duration = timeLineService(next_Billing_Date);
    return `${duration.label} ${duration.type}`;
  }

  goToSubscriptionDetails(ss: any) {
    this.subscriptionId = ss.id;
    this.localClientId = ss.client_id;
    this.subscriptionDetails = ss;
    this.showsubscriptionDetails = true;
    this.selectedSubscriptionIsRecurring = this.isRecurring(
      ss.subscription_category,
    );
  }

  isParentSubscription(subscription: any): boolean {
    if (!subscription) return false;
    const ownerSubsId = subscription.family_owner_subs_id || 0;
    const currentSubsId = subscription.clt_subs_id || subscription.id;
    return ownerSubsId > 0 && ownerSubsId === currentSubsId;
  }

  isChildSubscription(subscription: any): boolean {
    if (!subscription) return false;
    const ownerClientId =
      subscription.clt_subs_family_owner_client_id ||
      subscription.family_owner_client_id ||
      0;
    const currentSubsId = subscription.clt_subs_id || subscription.id;
    const ownerSubsId = subscription.family_owner_subs_id || 0;
    const isFamilyChild =
      subscription.clt_subs_is_family_child ?? subscription.is_family_child;
    return (
      ownerClientId > 0 && ownerSubsId !== currentSubsId && !!isFamilyChild
    );
  }

  getInterval(
    billing_interval_value: number,
    billing_interval_type: PlanIntervalType,
  ) {
    let str = '';
    if (
      billing_interval_type == PlanIntervalType.Month ||
      billing_interval_type?.toString() ==
        PlanIntervalType[PlanIntervalType.Month]
    ) {
      if (billing_interval_value > 1) str = 'months';
      else str = 'month';
    } else if (
      billing_interval_type == PlanIntervalType.Week ||
      billing_interval_type.toString() ==
        PlanIntervalType[PlanIntervalType.Week]
    ) {
      if (billing_interval_value > 1) str = 'weeks';
      else str = 'week';
    } else if (billing_interval_type == PlanIntervalType.Day) {
      if (billing_interval_value > 1) str = 'days';
      else str = 'day';
    }
    return str.toUpperCase();
  }

  getYear(dateYear: Date) {
    return new Date(dateYear).getFullYear();
  }

  ConvertToLocalTimezone(utcDate: Date | string) {
    return this.timeService.ConvertUTCToLocalDateTime(utcDate);
  }

  showSubscriptionStatus(status: string) {
    let colorCode = '';
    const data = SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    switch (data) {
      case SubscriptionStatus.Active:
        colorCode = 'bg-green-500';
        break;
      case SubscriptionStatus.Future:
        colorCode = 'bg-bluegray-100';
        break;
      case SubscriptionStatus.Cancelled:
        colorCode = 'bg-bluegray-500';
        break;
      case SubscriptionStatus.Frozen:
        colorCode = 'bg-cyan-500';
        break;
      case SubscriptionStatus.CancelledDueToNonPayment:
        colorCode = 'surface-500';
        break;
      case SubscriptionStatus.NotRenewing:
        colorCode = 'surface-500';
        break;
      case SubscriptionStatus.PendingForMandatoryAction:
        colorCode = 'bg-pink-500';
        break;
      case SubscriptionStatus.PendingForPaymentConfirmation:
        colorCode = 'bg-orange-500';
        break;
      case SubscriptionStatus.SuspendedDueToNonPayment:
        colorCode = 'surface-600';
        break;
      case SubscriptionStatus.Transfered:
        colorCode = 'bg-indigo-500';
        break;
      case SubscriptionStatus.Upgraded:
        colorCode = 'bg-teal-500';
        break;
      case SubscriptionStatus.Expired:
        colorCode = 'bg-red-500';
        break;
      case SubscriptionStatus.Void:
        colorCode = 'surface-500';
        break;
    }
    return colorCode;
  }

  subscriptionStatusTextColor(status: string) {
    let colorCode = '';
    const data = SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    switch (data) {
      case SubscriptionStatus.Active:
        colorCode = 'text-green-500';
        break;
      case SubscriptionStatus.Future:
        colorCode = 'text-blue-500';
        break;
      case SubscriptionStatus.Cancelled:
        colorCode = 'text-bluegray-500';
        break;
      case SubscriptionStatus.Frozen:
        colorCode = 'text-cyan-500';
        break;
      case SubscriptionStatus.CancelledDueToNonPayment:
        colorCode = 'text-surface-500';
        break;
      case SubscriptionStatus.NotRenewing:
        colorCode = 'text-surface-500';
        break;
      case SubscriptionStatus.PendingForMandatoryAction:
        colorCode = 'text-pink-500';
        break;
      case SubscriptionStatus.PendingForPaymentConfirmation:
        colorCode = 'text-orange-500';
        break;
      case SubscriptionStatus.SuspendedDueToNonPayment:
        colorCode = 'text-surface-600';
        break;
      case SubscriptionStatus.Transfered:
        colorCode = 'text-indigo-500';
        break;
      case SubscriptionStatus.Upgraded:
        colorCode = 'text-teal-500';
        break;
      case SubscriptionStatus.Expired:
        colorCode = 'text-red-500';
        break;
      case SubscriptionStatus.Void:
        colorCode = 'text-surface-500';
        break;
    }
    return colorCode;
  }

  showResendLink(subscription: any) {
    let signup = this.allSubscriptionsSingups$.value.find(
      (o: any) => o.client_subscription_id == subscription.id,
    );
    if(!signup) {
      signup = this.allsignups$.value.find(
        (o: any) => o.client_subscription_id == subscription.id,
      );
    }
    return (
      signup &&
      (subscription.status.toLowerCase() == 'pendingforpaymentconfirmation' ||
        subscription.status.toLowerCase() == 'pendingformandatoryaction')
    );
  }

  getSignupBySubscriptionId(subscriptionId: number) {
    let signup = this.allSubscriptionsSingups$.value.find(
      (o: any) => o.client_subscription_id == subscriptionId,
    );
    if(!signup) {
      signup = this.allsignups$.value.find(
        (o: any) => o.client_subscription_id == subscriptionId,
      );
    }
    return signup;
  }

  resendLinkForSubscription(subscription: any, channel: string) {
    let signup = this.allSubscriptionsSingups$.value.find(
      (o: any) => o.client_subscription_id == subscription.id,
    );
    if(!signup) {
      signup = this.allsignups$.value.find(
        (o: any) => o.client_subscription_id == subscription.id,
      );
    }
    if (signup) {
      this.resendLink(signup, channel);
    }
  }

  resendLink(signup: any, channel: string) {
    const channels: any[] = [];
    channels.push(channel);
    this.subscriptionService
      .resendPaymentLink(this.tenantId, this.clientId(), signup.uuid, channels)
      .subscribe({
        next: () => {
          this.translate
            .get('SUBSCRIPTIONS.MSG_RESEND_LINK')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
        },
        error: (error) => {
          if (error.originalError.status == 200) {
            this.toastMessageService.showSuccess(
              error.originalError.error.text,
            );
          } else if (
            error.originalError.error &&
            Array.isArray(
              error.originalError.error && error.originalError.error.length > 0,
            )
          ) {
            error.originalError.error.forEach((element: NotificationError) => {
              if (element.success) {
                this.translate
                  .get('SEND_EMAIL.MSG.EMAIL_SEND')
                  .subscribe((translation) => {
                    this.toastMessageService.showSuccess(translation);
                  });
              } else
                this.toastMessageService.showErrorMessage(
                  element.error.errorMessage,
                );
            });
          } else {
            this.handleError(error);
          }
        },
      });
  }

  VoidSignUp(signup: any) {
    this.voidSignUpBtnLoading = true;
    this.signUpDetails = signup;
    this.voidSignUpPopup = true;
  }

  confirm(event: Event) {
    if (this.VoidSubscriptionSignupForm.valid) {
      let translation: any;
      this.translate
        .get([
          'BILL_OWNER_CHANGE.CHANGE_INFO',
          'common.BUTTONS.BUTTON-TEXT-YES',
          'common.BUTTONS.BUTTON-TEXT-NO',
        ])
        .subscribe((translations) => {
          translation = translations;
        });
      this.confirmationService.confirm({
        target: event.target as EventTarget,
        key: 'activatemembership',
        message: 'Are you sure that you want to proceed?',
        icon: 'fa fa-exclamation-triangle',
        acceptLabel: translation['common.BUTTONS.BUTTON-TEXT-YES'],
        rejectLabel: translation['common.BUTTONS.BUTTON-TEXT-NO'],
        accept: () => {
          const changeRequest: any = {} as any;
          changeRequest.void_reasons =
            this.VoidSubscriptionSignupForm.value.void_reasons;
          this.subscriptionService
            .VoidSignUp(
              this.tenantId,
              this.clientId(),
              this.signUpDetails.id,
              changeRequest,
            )
            .subscribe({
              next: () => {
                this.translate
                  .get('SUBSCRIPTIONS.MSG.SIGNUP_VOID_MSG')
                  .subscribe((translation) => {
                    this.toastMessageService.showSuccess(translation);
                  });
                this.voidSignUpBtnLoading = false;
                this.voidSignUpPopup = false;
                this.VoidSubscriptionSignupForm.reset();
                this.componentInit();
              },
              error: (error) => {
                this.voidSignUpBtnLoading = false;
                if (error.originalError.status == 200) {
                  this.translate
                    .get('SUBSCRIPTIONS.MSG.SIGNUP_VOID_MSG')
                    .subscribe((translation) => {
                      this.toastMessageService.showSuccess(translation);
                    });
                  this.voidSignUpPopup = false;
                } else {
                  this.handleError(error);
                  this.voidSignUpPopup = false;
                }
              },
            });
        },
        reject: () => {
          this.voidSignUpPopup = false;
          this.voidSignUpBtnLoading = false;
          this.VoidSubscriptionSignupForm.reset();
        },
      });
    } else {
      Object.keys(this.VoidSubscriptionSignupForm.controls).forEach((field) => {
        const control = this.VoidSubscriptionSignupForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
    }
  }

  handleError(error: any) {
    this.toastMessageService.showError(error);
  }

  ShowToastErrors(error: any) {
    if (error.originalError.error && error.originalError.error.length > 0) {
      error.originalError.error.forEach((e: any) => {
        this.toastMessageService.showErrorMessage(e.errorMessage);
      });
    } else {
      if (error.originalError.error.errorMessage) {
        this.toastMessageService.showErrorMessage(
          error.originalError.error.errorMessage,
        );
      } else {
        this.translate
          .get([
            'common.errors.SERVER_SIDE.ERROR_OCCURRED',
            'common.errors.SERVER_SIDE.SOMETHING_WRONG',
          ])
          .subscribe((translations: any) => {
            this.toastMessageService.showErrorMessage(translations);
          });
      }
    }
  }

  getEventData(event: any) {
    if (event) this.reloadData = true;
  }

  numSequence(n: number): Array<number> {
    return Array(n);
  }

  getTenant(tenantId: number) {
    return this.allTenants.find((o: { id: number }) => o.id == tenantId);
  }

  IsSubscrptionVoidOrCancelled(status: string) {
    const subscrptionStatus =
      SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    return (
      subscrptionStatus == SubscriptionStatus.Void ||
      subscrptionStatus == SubscriptionStatus.Cancelled ||
      subscrptionStatus == SubscriptionStatus.Upgraded
    );
  }

  IsSubscriptionOpened(subscription: any) {
    if (
      this.allSubscriptionsSingups$.value.find(
        (o: { client_subscription_id: any; final_status: string }) =>
          o.client_subscription_id == subscription.id &&
          o.final_status == 'Open',
      )
    ) {
      return true;
    } else {
      return false;
    }
  }

  GetSubscriptionDetails(subscriptionId: number) {
    return this.allSubscriptions$.value.find(
      (o: { id: any }) => o.id == subscriptionId,
    );
  }

  getFilteredSubscriptions() {
    const data =
      this.selectedFilter === 'active'
        ? this.getAllActiveSubscriptions()
        : this.getAllExpiredSubscriptions();

    return this.sortSubscriptions(data);
  }

  getFilteredSubscriptionSignups() {
    const data =
      this.selectedFilter === 'active'
        ? this.getAllActiveSubscriptionSignups()
        : this.getAllExpiredSubscriptionSignups();

    return data.sort(
      (a: any, b: any) =>
        new Date(b.created_date).getTime() - new Date(a.created_date).getTime(),
    );
  }

  getSubscriptionTabCounts() {
    const activeSubscriptions = this.getAllActiveSubscriptions();
    const expiredSubscriptions = this.getAllExpiredSubscriptions();
    const activeSignups = this.getAllActiveSubscriptionSignups();
    const expiredSignups = this.getAllExpiredSubscriptionSignups();

    return {
      activeCount: activeSubscriptions.length + activeSignups.length,
      expiredCount: expiredSubscriptions.length + expiredSignups.length,
    };
  }

  get activeSubscriptionsCount() {
    return this.getSubscriptionTabCounts().activeCount;
  }

  get expiredSubscriptionsCount() {
    return this.getSubscriptionTabCounts().expiredCount;
  }

  private getAllActiveSubscriptions(): any[] {
    return this.allSubscriptions$.value.filter((subscription: any) =>
      this.isActiveSubscription(subscription),
    );
  }

  private getAllExpiredSubscriptions(): any[] {
    return this.allSubscriptions$.value.filter((subscription: any) =>
      this.isExpiredSubscription(subscription),
    );
  }

  private getAllActiveSubscriptionSignups(): any[] {
    const linkedSubscriptionIds = this.getLinkedSubscriptionIdsFromSignups();
    const signups = this.getUnlinkedSignups();

    if (linkedSubscriptionIds.length > 0) {
      return signups.filter(
        (signup: any) =>
          signup.final_status.toLowerCase() === 'open' &&
          !linkedSubscriptionIds.includes(signup.client_subscription_id) &&
          new Date(signup.link_expiry_date) > new Date(),
      );
    }

    return signups.filter(
      (signup: any) =>
        signup.final_status.toLowerCase() !== 'closed' &&
        new Date(signup.link_expiry_date) > new Date(),
    );
  }

  private getAllExpiredSubscriptionSignups(): any[] {
    const signupsById = new Map<number, any>();
    for (const signup of this.allSubscriptionsSingups$.value) {
      signupsById.set(signup.id, signup);
    }
    for (const signup of this.allsignups$.value) {
      if (signup.final_status?.toLowerCase() === 'closed') {
        signupsById.set(signup.id, signup);
      }
    }
    const signups = Array.from(signupsById.values());

    const distinctSignupIds = [
      ...new Set(
        signups
          .filter(
            (signup: any) =>
              signup.client_subscription_id > 0 &&
              (signup.final_status?.toLowerCase() === 'open' ||
                signup.final_status?.toLowerCase() === 'closed'),
          )
          .map((signup: any) => signup.id)
          .filter((id: number) => id > 0),
      ),
    ];

    return signups
      .filter((signup: any) => !distinctSignupIds.includes(signup.id))
      .filter(
        (signup: any) =>
          signup.final_status?.toLowerCase() === 'closed' ||
          new Date(signup.link_expiry_date) < new Date(),
      );
  }

  private getLinkedSubscriptionIdsFromSignups(): number[] {
    return [
      ...new Set<number>(
        this.allSubscriptionsSingups$.value
          .filter(
            (signup: any) =>
              (signup.final_status.toLowerCase() === 'closed' ||
                signup.final_status.toLowerCase() === 'open') &&
              signup.client_subscription_id > 0,
          )
          .map((signup: any) => signup.client_subscription_id as number)
          .filter((id: number) => id > 0),
      ),
    ];
  }

  private getUnlinkedSignups(): any[] {
    const distinctSignupIds = [
      ...new Set(
        this.allSubscriptionsSingups$.value
          .filter(
            (signup: any) =>
              signup.client_subscription_id > 0 &&
              (signup.final_status.toLowerCase() === 'open' ||
                signup.final_status.toLowerCase() === 'closed'),
          )
          .map((signup: any) => signup.id)
          .filter((id: number) => id > 0),
      ),
    ];

    return this.allSubscriptionsSingups$.value.filter(
      (signup: any) => !distinctSignupIds.includes(signup.id),
    );
  }

  private sortSubscriptions(data: any[]): any[] {
    return data.sort((a: any, b: any) => {
      if (
        a.status.toLowerCase() === 'active' &&
        b.status.toLowerCase() !== 'active'
      ) {
        return -1;
      }
      if (
        a.status.toLowerCase() !== 'active' &&
        b.status.toLowerCase() === 'active'
      ) {
        return 1;
      }

      return (
        new Date(b.created_date).getTime() - new Date(a.created_date).getTime()
      );
    });
  }

  private isActiveSubscription(subscription: {
    status?: string;
  }): boolean {
    const status = subscription?.status?.toLowerCase();
    if (!status) {
      return false;
    }

    return (
      status === 'active' ||
      status === 'pendingforpaymentconfirmation' ||
      status === 'pendingformandatoryaction' ||
      status === 'future' ||
      status === 'notrenewing' ||
      status === 'frozen' ||
      status === 'suspendedduetononpayment'
    );
  }

  private isExpiredSubscription(subscription: {
    status?: string;
    upgrade_to_clt_subs_id?: number;
  }): boolean {
    const status = subscription?.status?.toLowerCase();
    if (!status) {
      return false;
    }

    return (
      status === 'expired' ||
      status === 'cancelled' ||
      status === 'transfered' ||
      status === 'void' ||
      (status === 'upgraded' &&
        Number(subscription.upgrade_to_clt_subs_id ?? 0) === 0) ||
      status === 'cancelledduetononpayment'
    );
  }

  get inProgressSubscriptionsCount() {
    const distinctIds = [
      ...new Set(
        this.allSubscriptions$.value
          .filter((f: any) => f.id > 0 && f.status.toLowerCase() == 'active')
          .map((obj: any) => obj.id)
          .filter((id: number) => id > 0),
      ),
    ];
    const data = this.allSubscriptionsSingups$.value.filter(
      (o: any) => !distinctIds.includes(o.client_subscription_id),
    );
    return (
      data.filter((o: any) => o.final_status.toLowerCase() == 'open').length ||
      0
    );
  }

  get allSubscriptionsCount() {
    return (
      this.activeSubscriptionsCount +
      this.expiredSubscriptionsCount +
      this.inProgressSubscriptionsCount
    );
  }

  isUpgraded(subscription: any) {
    if (subscription && subscription.upgrade_from_clt_subs_id > 0) return true;
    else return false;
  }

  getFromUpgradeSubs(subscriptionId: number) {
    return this.allSubscriptions$
      .getValue()
      .find((o: { id: number }) => o.id == subscriptionId);
  }

  isTransferred(subscription: any): boolean {
    return !!(
      subscription?.transfer_type &&
      (subscription.transfer_from_tenant_id > 0 ||
        subscription.transfer_to_tenant_id > 0 ||
        subscription.transfer_from_client?.id > 0 ||
        subscription.transfer_to_client?.id > 0)
    );
  }

  isLocationTransfer(subscription: any): boolean {
    return subscription?.transfer_type === 'LocationToLocation';
  }

  getTransferFromName(subscription: any): string {
    if (this.isLocationTransfer(subscription)) {
      const tenant = this.allTenants?.find(
        (o: { id: number }) => o.id == subscription.transfer_from_tenant_id,
      );
      return (
        tenant?.name_primary_language || tenant?.name_secondary_language || ''
      );
    }
    return subscription.transfer_from_client?.full_name || '';
  }

  getTransferToName(subscription: any): string {
    if (this.isLocationTransfer(subscription)) {
      const tenant = this.allTenants?.find(
        (o: { id: number }) => o.id == subscription.transfer_to_tenant_id,
      );
      return (
        tenant?.name_primary_language || tenant?.name_secondary_language || ''
      );
    }
    return subscription.transfer_to_client?.full_name || '';
  }

  getTransferFromId(subscription: any): number {
    if (this.isLocationTransfer(subscription)) {
      return subscription.transfer_from_tenant_id;
    }
    return subscription.transfer_from_client?.id || 0;
  }

  getTransferToId(subscription: any): number {
    if (this.isLocationTransfer(subscription)) {
      return subscription.transfer_to_tenant_id;
    }
    return subscription.transfer_to_client?.id || 0;
  }

  isTransferredFrom(subscription: any): boolean {
    if (this.isLocationTransfer(subscription)) {
      return (
        subscription.transfer_from_tenant_id > 0 &&
        subscription.transfer_from_tenant_id !== this.tenantId
      );
    }
    // Show "transferred from X" when the current client is the recipient (transfer_to)
    return (
      subscription.transfer_to_client?.id === this.clientId() &&
      subscription.transfer_from_client?.id > 0
    );
  }

  isTransferredTo(subscription: any): boolean {
    if (this.isLocationTransfer(subscription)) {
      return (
        subscription.transfer_to_tenant_id > 0 &&
        subscription.transfer_to_tenant_id !== this.tenantId
      );
    }
    // Show "transferred to X" when the current client is the sender (transfer_from)
    return (
      subscription.transfer_from_client?.id === this.clientId() &&
      subscription.transfer_to_client?.id > 0
    );
  }

  truncatedText(url: string): string {
    if (url.length > 20) {
      return url.slice(0, 20) + '...';
    } else {
      return url;
    }
  }

  PaymentMethodDetails(paymentMethod: PaymentMethod) {
    const paymentData: any = {};
    const data =
      PayModeLevel1[
        paymentMethod.level1.toString() as keyof typeof PayModeLevel1
      ];
    switch (data) {
      case PayModeLevel1.Cash:
        paymentData.img = '/assets/img/icons/icon-cash.svg';
        paymentData.icon = 'fab fa-cc-visa';
        this.translate
          .get('SUBSCRIPTIONS.CARD-ENDING-WITH', { number: '****' })
          .subscribe((translations: any) => {
            paymentData.number = translations;
          });
        break;
      case PayModeLevel1.ACH:
        paymentData.img = '/assets/img/ach-options.svg.png';
        paymentData.icon = 'fab fa-cc-visa';
        this.translate
          .get('SUBSCRIPTIONS.CARD-ENDING-WITH', { number: '****' })
          .subscribe((translations: any) => {
            paymentData.number = translations;
          });
        break;
      case PayModeLevel1.Adjustment:
        paymentData.img = '/assets/img/icons/icon-adjustment.svg';
        paymentData.icon = 'fab fa-cc-visa';
        this.translate
          .get('SUBSCRIPTIONS.CARD-ENDING-WITH', { number: '****' })
          .subscribe((translations: any) => {
            paymentData.number = translations;
          });
        break;
      case PayModeLevel1.Card:
        if (paymentMethod.network_type.toLowerCase() == 'mastercard')
          paymentData.img = '/assets/img/mastercard.png';
        else paymentData.img = '/assets/img/visa.png';
        paymentData.icon = 'fab fa-cc-visa';
        this.translate
          .get('SUBSCRIPTIONS.CARD-ENDING-WITH', {
            number: paymentMethod.masked_card_number,
          })
          .subscribe((translations: any) => {
            paymentData.number = translations;
          });

        break;
      case PayModeLevel1.Cheque:
        paymentData.img = '/assets/img/icons/icon-cheque.svg';
        paymentData.icon = 'fab fa-cc-visa';
        this.translate
          .get('SUBSCRIPTIONS.CARD-ENDING-WITH', { number: '****' })
          .subscribe((translations: any) => {
            paymentData.number = translations;
          });
        break;
      case PayModeLevel1.Emandate:
        paymentData.img = '/assets/img/icons/icon-emandate.svg';
        paymentData.icon = 'fab fa-cc-visa';
        this.translate
          .get('SUBSCRIPTIONS.CARD-ENDING-WITH', { number: '****' })
          .subscribe((translations: any) => {
            paymentData.number = translations;
          });
        break;
      case PayModeLevel1.NetBanking:
        paymentData.img = '/assets/img/bank-payment-img.svg';
        paymentData.icon = 'fab fa-cc-visa';
        this.translate
          .get('SUBSCRIPTIONS.CARD-ENDING-WITH', {
            number: paymentMethod.masked_account_number
              ? paymentMethod.masked_account_number
              : '****',
          })
          .subscribe((translations: any) => {
            paymentData.number = translations;
          });
        break;
      case PayModeLevel1.UPI:
        paymentData.img = '/assets/img/logo-upi.svg';
        paymentData.icon = 'fab fa-cc-visa';
        paymentData.number = paymentMethod.vpa_id;
        break;
      case PayModeLevel1.Wallet:
        paymentData.img = '/assets/img/icons/icon-wallet.svg';
        paymentData.icon = 'fab fa-cc-visa';
        this.translate
          .get('SUBSCRIPTIONS.CARD-ENDING-WITH', { number: '****' })
          .subscribe((translations: any) => {
            paymentData.number = translations;
          });
        break;
      case PayModeLevel1.Other:
        paymentData.img = '/assets/img/icons/icon-others-method.svg';
        paymentData.icon = 'fab fa-cc-visa';
        this.translate
          .get('SUBSCRIPTIONS.CARD-ENDING-WITH', { number: '****' })
          .subscribe((translations: any) => {
            paymentData.number = translations;
          });
        break;
      case PayModeLevel1.PayTo:
        paymentData.img = '/assets/img/icons/icon-payto.svg';
        paymentData.icon = 'fab fa-cc-visa';
        paymentData.number = paymentMethod.pay_to_details;
        break;
    }
    return paymentData;
  }

  isNotRenewingStatus(status: string) {
    const subscrptionStatus =
      SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    return subscrptionStatus == SubscriptionStatus.NotRenewing;
  }

  get ChangeReasonFormControl(): UntypedFormControl {
    return this.VoidSubscriptionSignupForm.controls
      .void_reasons as UntypedFormControl;
  }

  closeAddonSidebar(event: { event: any; subscription: any }) {
    this.showAddonSidebar = false;
    this.splashScreen.showSpinner();
    this.selectedAddons.next(event.event.selectedAddons);
    const subscriptionDetails = event.subscription;
    if (this.selectedAddons.value.length > 0 && event.event.callbreakup) {
      const client = this.routerservice.getClient();
      const planSummaryClient = {} as PlanSummaryClient;
      planSummaryClient.client_id = this.clientId();
      planSummaryClient.client_name = client?.full_name || '';
      planSummaryClient.client_keyfob = client?.current_keyfob || '';
      planSummaryClient.client_image = client?.image || '';
      if (client?.client_status)
        planSummaryClient.client_status = client?.client_status.toString() || '';

      const planSummary = {} as PlanSummary;
      planSummary.id = subscriptionDetails.plan_id;
      planSummary.company_id = subscriptionDetails.company_id;
      planSummary.tenant_id = subscriptionDetails.tenant_id;
      planSummary.plan_selectable = false;
      planSummary.client = planSummaryClient;
      planSummary.from_subscription_id = subscriptionDetails.id;
      planSummary.SignUpMode = SignUpMode.MidCycleAddons;
      planSummary.addons = this.selectedAddons.value;
      this.planSummarydataObject = of(planSummary);
      setTimeout(() => {
        this.showBillingSidebar = true;
        this.splashScreen.hideSpinner();
        this.changeDetectorRef.detectChanges();
      }, 300);
    } else {
      this.showBillingSidebar = false;
      this.splashScreen.hideSpinner();
      this.changeDetectorRef.detectChanges();
    }
  }

  HideBillingSummary(event: any) {
    this.showBillingSidebar = false;
    this.showAddonSidebar = false;
  }

  GoToClientDetails(event: any) {
    this.showBillingSidebar = false;
    this.showAddonSidebar = false;
  }

  emitEvents(event: any) {
    if (event) this.componentInit();
  }

  getSubscription(subscriptionId: number) {
    return this.allSubscriptions$.value.find(
      (o: { id: number }) => o.id == subscriptionId,
    )!;
  }

  isPresalePurchased(subscription: any) {
    return subscription.is_presale;
  }

  isRecurring(subscriptionCategory: any) {
    return (
      subscriptionCategory == PlanCategory.Contract ||
      subscriptionCategory.toString() == PlanCategory[PlanCategory.Contract] ||
      subscriptionCategory == PlanCategory.PayAsYouGo ||
      subscriptionCategory.toString() == PlanCategory[PlanCategory.PayAsYouGo]
    );
  }

  isBillingStopped(subscription: { stop_billing?: boolean }): boolean {
    return subscription?.stop_billing === true;
  }

  isStatusOverridden(subscription: { is_status_overridden?: boolean }): boolean {
    return this.getStatusOverriddenValue(subscription) === true;
  }

  getRecurringServicesText(subscription: any) {
    let text = '';
    subscription.recurring_template_recurring_services.forEach(
      (service: any, index: number) => {
        if (service.service_is_base_membership) {
          text += this.translate.instant('SUBSCRIPTIONS.BASE-MEMEBERSHIP');
        } else {
          text +=
            service.service_type_name_primary_language ||
            service.service_type_name_secondary_language + ' ';
        }
        if (
          index <
          subscription.recurring_template_recurring_services.length - 1
        ) {
          text += ' + ';
        }
      },
    );
    return text;
  }

  getNonRecurringServicesText(subscription: any) {
    let text = '';
    subscription.recurring_template_recurring_services?.forEach(
      (service: any, index: number) => {
        if (service.service_is_base_membership) {
          text += this.translate.instant('SUBSCRIPTIONS.BASE-MEMEBERSHIP');
        } else {
          text +=
            service.service_type_name_primary_language ||
            service.service_type_name_secondary_language + ' ';
        }
        if (
          index <
          subscription.recurring_template_recurring_services.length - 1
        ) {
          text += ' + ';
        }
      },
    );
    return text;
  }

  getTrackMode(subscription: any) {
    let modeText: string = '';
    if (
      subscription.track_mode == TrackMode.ClientPurchasePortal ||
      subscription.track_mode?.toString() ==
        TrackMode[TrackMode.ClientPurchasePortal]
    ) {
      this.translate
        .get('SUBSCRIPTIONS.TRACK_MODE_PP')
        .subscribe((translations: any) => {
          modeText = translations;
        });
    } else if (
      subscription.track_mode == TrackMode.ClientMobileApp ||
      subscription.track_mode?.toString() ==
        TrackMode[TrackMode.ClientMobileApp]
    ) {
      this.translate
        .get('SUBSCRIPTIONS.TRACK_MODE_APP')
        .subscribe((translations: any) => {
          modeText = translations;
        });
    } else {
      modeText = '';
    }
    return modeText;
  }

  getSignupProgress(signup: any) {
    // For signups with final_status 'open'
    if (signup.final_status.toLowerCase() === 'open') {
      // Check if there's a corresponding subscription with pending status
      const subscription = this.allSubscriptions$.value.find(
        (s: any) => s.id === signup.client_subscription_id,
      );

      if (subscription) {
        if (subscription.status === 'PendingForMandatoryAction') {
          return {
            value: 50,
            status: 'warn',
            text: 'Pending Mandatory Action',
          };
        } else if (subscription.status === 'PendingForPaymentConfirmation') {
          return {
            value: 75,
            status: 'info',
            text: 'Pending Payment Confirmation',
          };
        }
      }

      // Default for open signups without matching subscription
      return {
        value: 25,
        status: 'primary',
        text: 'In Progress',
      };
    }

    // For closed signups
    return {
      value: 100,
      status: 'success',
      text: 'Completed',
    };
  }

  getTagStyle(tokenStatus: string): string {
    switch (tokenStatus) {
      case 'initiated':
        return 'bg-primary';
      case 'confirmed':
        return 'bg-green-500';
      case 'rejected':
        return 'bg-bluegray-500';
      case 'cancelled':
        return 'bg-red';
      case 'paused':
        return 'bg-orange-500';
      default:
        return '';
    }
  }

  copyToClipboard(text: string) {
    const textArea = this.document.createElement('textarea');
    textArea.value = text;
    this.document.body.appendChild(textArea);
    textArea.select();

    try {
      this.document.execCommand('copy');
      this.translate
        .get('common.message.COPY_SUCCESS')
        .subscribe((message: string) => {
          this.toastMessageService.showSuccess(message);
        });
      this.document.body.removeChild(textArea);
    } catch (err) {
      this.toastMessageService.showError(err);
      this.document.body.removeChild(textArea);
    } finally {
      this.document.body.removeChild(textArea);
    }
  }

  closeQrCode() {
    this.showQRCode = false;
    this.qrCodeLink = '';
  }

  get showSkeleton() {
    return this.showSkeleton$.value;
  }

  isPendingForMandatoryAction(status: string): boolean {
    return status.toLowerCase() === 'pendingformandatoryaction';
  }

  showPendingActionsDetails(subscription: any, event: Event) {
    event.stopPropagation();
    if (subscription.pending_for_mandatory_action_details) {
      this.selectedPendingDetails =
        subscription.pending_for_mandatory_action_details;
      this.selectedSubscriptionAutopay =
        subscription.is_autopay_enabled || false;
      this.showPendingActionsPopup = true;
    }
  }

  closePendingActionsPopup() {
    this.showPendingActionsPopup = false;
    this.selectedPendingDetails = null;
    this.selectedSubscriptionAutopay = false;
  }

  closeProfileTab() {
    this.routerservice.closeClientSidebar(true);
    this.routerservice.setCloseOmniSearchSidebarAll(true);
  }
}
